<script>
  import { layoutMethods  } from "@/state/helpers";
  // import { contactListData } from "./data-list";
  import { kantoAdsMethods, kantoAdsComputed, exportMethods, erpFixMessages  } from "@/state/helpers";
  import Swal from "sweetalert2";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";

  export default {
    page: {
      title: "Audit"
    },
    data() {
      return {
        title: "Audit",
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90 ,100],
        filter: null,
        filterOn: [],
        sortBy: "value",
        sortDesc: false,
        isLightboxVisible: false,
        lightBoxImageUrl: "",
        imageProps: {
          center: true,
          fluidGrow: false,
          fluid: false,
          blankColor: '#bbb',
          width: 50,
          height: 50,
          class: 'image-thumbnail'
        },
        searchOptions: [
          { text: 'Search All', value: null },
          { text: 'Store Name', value: 'tmcd.store_name' },
          { text: 'Mobile', value: 'tmcd.mobile_number' },
          { text: 'Collaterals', value: 'tmcd.type' }
        ],
        filterOptions: [
          { text: 'All', value: null },
          { text: 'Brand Action Form', value: 'tmad.audit_status' },
          { text: 'SSS Tarpulin Status', value:  'tmad.collateral_status'},
          { text: 'Rented By', value: 'tmah.organization_id' },
        ],


        filterByStatusOptions: [
          { text: 'Good', value: 'Good' },
          { text: 'Damaged', value: 'Damaged' }
        ],
        filterByBrandActionOptions: [
          { text: 'Approve Current Condition - Good', value: 'approved_good' },
          { text: 'Approve Current Condition - Full Payment', value: 'approved_full' },
          { text: 'Resend Collaterals', value: 'onHold' },
          { text: 'Continue with Contract Cancellation - w/ cancellation fee', value: 'cancelled_continue' },
          { text: 'Collateral Unusable - Cancel Contract', value: 'cancelled_unusable' },
          { text: 'Pending Approval ERP', value: 'cancelled_await' }
          
        ],
        filterValue: {
            name: null,
            field: null,
        },
        searchValue: {
            name: null,
            field: null,
            filter: null,
            dateRange: null,
            action: null,
            status: null,
        },
        fields: [
          {
            key: "businessName",
            label: "Store Name",
            sortable: true,
          }, 
          {
            key: "businessMobile",
            label: "Store Mobile",
            sortable: true,
          },
          {
            key: "collateralConditions",
            label: "SSS Tarpulin Status",
            sortable: true,
          },
          {
            key: "collateralAuditConditions",
            label: "Brand Action Form",
            sortable: true,
          },
          {
            key: "collateralImageUrl",
            label: "Checkpoint Image",
            sortable: false,
          },
          {
            key: "collateralType",
            label: "Collateral Type",
            sortable: true,
          },
          {
            key: "collateralPlacement",
            label: "Placement",
            sortable: true,
          },
          {
            key: "collateralDimension",
            label: "Size",
            sortable: true,
          },
          {
            key: "organizationName",
            label: "Rented By",
            sortable: true,
          },
          {
            key: "checkpointDate",
            label: "Checkpoint Date",
            sortable: true,
          },
        ],
        pagination: {
            "page": 1,
            "rows" : 10,
            "search": "",
        },
        rangeOption: {
          mode: "range",
        },
      };
    },
    components: { 
      flatPickr
    },
    computed: {
      ...kantoAdsComputed,
      ...erpFixMessages
    },
    methods: {
      ...layoutMethods,
      ...kantoAdsMethods,
      ...exportMethods,
      filterLabel() {
        const matchingOption = this.filterOptions.find(
          (option) => option.value === this.filterValue.field
        )
        return matchingOption ? matchingOption.text : 'Filter';
      },
      async onExport(){
          await this.onPageUpdate();
          if(this.auditDataTotalRows == 0)
          {
            Swal.fire("Failed!", this.exportNullPrompt, "warning");
            return;
          }
          let params = {...this.pagination, email: JSON.parse(localStorage.getItem("userData")).email, module: 'kantoads_audit_space'};
          console.log("params: ", params);
          
          this.exportReport(params)
            .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
            .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      },
      getActionStatus(action) 
      {
        const matchingOption = this.filterByBrandActionOptions.find(
          (option) => option.value == action
        );

        return matchingOption ? matchingOption.text : '';
      },
      getConditionColor(condition) {
        return condition === 'Good' ? 'green' : 'red'
      },
      async populateKantoAdsAuditTable(){
        await this.onPageUpdate();
      },
      async onPageUpdate(status) {
          if(status == "reset"){
            this.pagination.page = 1;
          }

          let custom_filter;

          if(this.filterValue.field === 'tmad.collateral_status' || this.filterValue.field === 'tmad.audit_status')
          {
              custom_filter = this.filterValue.status;
          }
          // else if(this.filterValue.field === 'tmad.audit_status')
          // {
          //   custom_filter = this.filterValue.action;
          // }
          else custom_filter = this.filterValue.name
          
          this.pagination.search = {
              keyword: this.searchValue.name,
              searchField: this.searchValue.field,
              filter: custom_filter,
              filterBy: this.filterValue.field,
              dateRange: this.searchValue.dateRange
          }
          console.log("this.searchValue.dateRange: ", this.searchValue.dateRange);
          console.log(`this.pagination:`, this.pagination.search);

          
          await this.listAuditData(this.pagination);

          console.log("auditData: ", this.auditData);
      },
      refresh(){
        this.searchValue.name = null;
        this.filterValue.name = null;
        this.filterValue.field = null;
        // this.filterValue.action = null;
        this.filterValue.status = null;
        this.searchValue.dateRange = null;
        this.pagination.page = 1;
        this.populateKantoAdsAuditTable();
        
      },
      tableSorting(action) { // Just incase we need this
        var column = "";
        this.pagination.sort = column;
        this.pagination.orderDesc = action.sortDesc;
        this.listAuditData(this.pagination)
      },
    },
    watch: {
      'filterValue.field': {
        handler(value) {
          console.log("filterValue.field: ", value);
          if(value === 'tmad.collateral_status')
          {
            this.filterValue.status = 'Good';
          }
          else if(value === 'tmad.audit_status')
          {
            this.filterValue.status = 'approved';
            // this.filterValue.action = 'is_empty';
          }
        },
        immediate: true
      },
    },

    mounted(){
      this.populateKantoAdsAuditTable();
      this.changeTitle({title: 'Audit'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Kanto Ads', to: { name: 'Kanto Ads'} },
          { text: 'Audit', to: { name: 'Audit Space'} }
        ]
      });
    }
  }
    
</script>

<template>
  <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4 mb-4">
                <div class="my-2">
                  <h5 class="card-title text-dark">
                    <span class="fw-normal ms-lg-2">{{auditDataTotalRows}}</span> Record(s)
                  </h5>
                </div>
              </div>

              <div class="col-md-8 col-sm-8">
                  <div class="d-flex justify-content-lg-end mb-lg-3">
                    
                      <a class="btn btn-secondary"
                        @click="refresh"
                          ><feather
                          type="refresh-ccw"
                          size="16"
                          class="icon nav-icon"
                          ></feather
                          > &nbsp; Refresh</a
                      >
                  </div>
              </div>
              <div class="row">
                <div class="w-auto mb-2">
                  <div class="d-flex mt-3 mb-3">
                    <div class="me-3">
                      <form class="d-flex" @submit.prevent="onPageUpdate('reset')">
                        <b-form-group id="input-group-3" label-for="input-3">
                          <b-form-select class="form-select rounded-0 rounded-start shadow-none w-200px" id="input-3" v-model="searchValue.field" :options="searchOptions"></b-form-select>
                        </b-form-group>
                        <b-form-group id="input-group-3" class="text-align-right" label-for="input-3">
                          <template v-slot:description><div class="d-flex justify-content-end">Search for keyword</div></template>
                          <b-form-input id="input-keyword" v-model="searchValue.name" class="rounded-0" style="width: auto"></b-form-input>
                        </b-form-group>
                      </form>
                    </div>
                    <div class="me-3">
                      <b-form-group id="input-group-3" label-for="input-3">
                        <template v-slot:description><div class="d-flex justify-content-end">Filter By</div></template>
                        <b-form-select class="form-select rounded-0 rounded-start shadow-none w-150px" id="input-3" v-model="filterValue.field" :options="filterOptions"></b-form-select>
                      </b-form-group>
                    </div>
                    <div class="me-3">
                      <form @submit.prevent="onPageUpdate('reset')">
                        <b-form-group id="input-group-3" label-for="input-3">
                          <template v-slot:description><div v-if="filterValue.field == 'tmad.collateral_status' || filterValue.field == 'tmad.audit_status' || filterValue.field == 'tmah.organization_id'" class="d-flex justify-content-end" >{{filterLabel()}}</div></template>
                          <b-form-group id="input-group-3" class="text-align-right" label-for="input-3">
                            <b-form-input v-if="filterValue.field != 'tmad.collateral_status' && filterValue.field != 'tmad.audit_status' && !(filterValue.field != 'tmah.organization_id' && filterValue.field != 'tmad.collateral_status' && filterValue.field != 'tmad.audit_status')" id="input-keyword" v-model="filterValue.name" class="rounded-0 filter-width"></b-form-input>
                            <b-form-select  v-if="filterValue.field === 'tmad.collateral_status'" class="form-select rounded-0 rounded-start shadow-none filter-width" id="input-3" v-model="filterValue.status" :options="filterByStatusOptions"></b-form-select>
                            <b-form-select  v-if="filterValue.field === 'tmad.audit_status'" class="form-select rounded-0 rounded-start shadow-none filter filter-width" id="input-3" v-model="filterValue.status" :options="filterByBrandActionOptions"></b-form-select>
                          </b-form-group>
                        </b-form-group>
                      </form>
                    </div>

                    
                    <div class="me-3">
                      <b-form-group>
                        <template v-slot:description><div class="d-flex justify-content-end">Filter by Checkpoint Date</div></template>
                        <flat-pickr
                          v-model="searchValue.dateRange"
                          :config="rangeOption"
                          placeholder="Select a date range"
                          class="form-control"
                          style="width: fit-content"
                        ></flat-pickr>
                      </b-form-group>
                    </div>
                    <div class="me-3">
                      <b-form-group label="">
                        <b-button variant="primary" type="button" @click="onPageUpdate('reset')" class="px-2">
                          <i class='bx bx-search bx-fw'></i>
                          Search
                        </b-button>
                      </b-form-group>
                    </div>
                    <div>
                      <b-form-group label="">
                        <a href="javascript:void(0);" class="btn btn-primary me-2" data-bs-toggle="modal" @click="onExport">
                          <i class="uil uil-export me-1"></i>Export
                        </a>
                      </b-form-group>
                    </div>
                  </div>
                  
                </div>
              </div>
              <div class="table-responsive">
                <div class="table align-middle table-nowrap">
                  <b-table
                    :items="auditData"
                    :fields="fields"
                    responsive="md"
                    :current-page="currentPage"
                    class="table-check"
                  >
                    <template #cell(businessName)="data">
                      <span class="text-body m-0"><span class="customer-name">{{ data.item.businessName }}</span></span>
                    </template>
                    <template #cell(collateralConditions)="data">
                      <span :style="{ color: getConditionColor(data.item.collateralConditions) }">
                        {{ data.item.collateralConditions }}
                      </span>
                    </template>
                    <template #cell(collateralAuditConditions)="data">
                      <!-- <span :style="{ color: getConditionColor(data.item.collateralAuditConditions) }"> -->
                      <span>
                        {{ getActionStatus(data.item.collateralAuditConditions) }}
                      </span>
                    </template>
                    <template #cell(collateralImageUrl)="data">
                      <b-img v-bind="imageProps" :src="data.item.collateralImageUrl" @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')" alt="Image 3" @click="lightBoxImageUrl = data.item.collateralImageUrl; isLightboxVisible = true;"></b-img>
                    </template>
                    <template #cell(collateralType)="data">
                      {{ data.item.collateralType != null ? data.item.collateralType.charAt(0).toUpperCase() + data.item.collateralType.slice(1) : '' }}
                    </template>
                    <template #cell(checkpointDate)="data">
                      {{ data.item.checkpointDate | customFormatDate }}
                    </template>
                  </b-table>
                </div>
              </div>
              <vue-easy-lightbox
                  :visible="isLightboxVisible"
                  :imgs="lightBoxImageUrl"
                  @hide="isLightboxVisible = false"
              ></vue-easy-lightbox>
              <div class="row g-0 text-center" v-if="auditDataTotalRows == 0">
                <span>No data to display.</span>
              </div>
              <div class="row g-0 text-center text-sm-start" v-if="auditDataTotalRows != 0 && auditDataTotalRows > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="pagination.rows"
                            :options="pageOptions"
                            @change="onPageUpdate()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                    >
                      <!-- pagination -->
                      <div class="row g-0 text-center" v-if="auditDataTotalRows == 0">
                        <span>No data to display.</span>
                      </div>
                      <b-pagination
                        v-if="auditDataTotalRows != 0 && auditDataTotalRows > pagination.rows"
                        class="pagination-rounded"
                        v-model="pagination.page"
                        :total-rows="auditDataTotalRows"
                        @input="onPageUpdate()"
                        :per-page="pagination.rows"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
</template>


<style scoped>

  .filter-width {
    width: 150px !important;
  }
  .btn {
    cursor: pointer;
  }
  b-form-select-option[value="Good"] {
    color: green; /* Change the text color for Option 1 to green */
  }
  .customer-name {
    color: #C3297C;
  }
  .image-thumbnail {
    cursor: pointer;
    border: 5px grey;
  }
</style>